import React from 'react';
import * as DatesUtils from '../../utils/dates';
import _ from 'lodash';
import { Languages } from 'config';
import ActionsBlock from './components/datatable/ActionsBlock';

const CONFIGURATION = {};

export default CONFIGURATION;

export const TableColumns = [
  {
    label: '#',
    id: 'payment_reminder_msid_id',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: Array<any>
    ) => <React.Fragment>{cellValue}</React.Fragment>,
    inData: true,
  },
  {
    label: 'Applicant VAT Number',
    id: 'vat_id_num',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: Array<any>
    ) => <React.Fragment>{cellValue}</React.Fragment>,
    inData: true,
  },
  {
    label: 'VAT Return Reference Number',
    id: 'vat_return_reference',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: Array<any>
    ) => <React.Fragment>{cellValue}</React.Fragment>,
    inData: true,
  },
  // {
  //   label: 'Concerned Country',
  //   id: 'destination_country',
  //   render: (
  //     rowIndex: number,
  //     cellValue: any,
  //     columnIndex: number,
  //     data: Array<any>
  //   ) => <React.Fragment>{cellValue}</React.Fragment>,
  //   inData: true,
  // },
  // {
  //   label: 'Vat Return Version',
  //   id: 'vat_return_version_id',
  //   render: (
  //     rowIndex: number,
  //     cellValue: any,
  //     columnIndex: number,
  //     data: Array<any>
  //   ) => <React.Fragment>{cellValue}</React.Fragment>,
  //   inData: true,
  // },
  {
    label: 'Reminded Date',
    id: 'reminded_date',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: Array<any>
    ) => <React.Fragment>{DatesUtils.formatDate(cellValue)}</React.Fragment>,
    inData: true,
  },
  {
    label: 'Sent?',
    id: 'is_sent',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: Array<any>
    ) => <React.Fragment>{cellValue ? 'Yes' : 'No'}</React.Fragment>,
    inData: true,
  },
  // {
  //   label: 'Actions',
  //   align: 'center',
  //   id: 'action1',
  //   render: (
  //     rowIndex: number,
  //     cellValue: any,
  //     columnIndex: number,
  //     data: any
  //   ) => (
  //     <ActionsBlock
  //       rowIndex={rowIndex}
  //       error={data[rowIndex].error}
  //       message_text={data[rowIndex].message_text}
  //       vat_return_reminder_id={data[rowIndex].vat_return_reminder_id}
  //     />
  //   ),
  //   inData: false,
  // },
];

export const Translations = {
  page_title: {
    [Languages.Greek]: 'Payment Reminders (MSCON) - Pending Development',
    [Languages.English]: 'Payment Reminders (MSCON) - Pending Development',
  },
  table_title: {
    [Languages.Greek]: 'Generated Payment Reminders (MSCON)',
    [Languages.English]: 'Generated Payment Reminders (MSCON)',
  },
  generate_button: {
    [Languages.Greek]: 'Generate MSCON Payment Reminders',
    [Languages.English]: 'Generate MSCON Payment Reminders',
  },
  go_to_dashboard: {
    [Languages.Greek]: 'Go to dasbhoard',
    [Languages.English]: 'Go to dasbhoard',
  },
  search: {
    [Languages.Greek]: 'Search',
    [Languages.English]: 'Search',
  },
  clear: {
    [Languages.Greek]: 'Clear',
    [Languages.English]: 'Clear',
  },
  vat_number_search_control: {
    [Languages.Greek]: 'Applicant VAT Number',
    [Languages.English]: 'Applicant VAT Number',
  },
  vat_return_reference_search_control: {
    [Languages.Greek]: 'VAT Return Reference Number',
    [Languages.English]: 'VAT Return Reference Number',
  },
  reminded_date_from: {
    [Languages.Greek]: 'Reminded Date From',
    [Languages.English]: 'Reminded Date From',
  },
  reminded_date_to: {
    [Languages.Greek]: 'Reminded Date To',
    [Languages.English]: 'Reminded Date To',
  },
};
